export default __webpack_public_path__ + "static/media/no-crowd.1b3cdfc0.png";